import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../utils/intercepter/axiosConfig';

const MesHypotheques = () => {
  const navigate = useNavigate();

  const [hypotheques, setHypotheques] = useState([]);
  const [idUser, setIduser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setIduser(decoded.data.id);
      } catch (error) {
        console.log("Token invalid");
        setError('Token invalide');
        setLoading(false);
      }
    } else {
      setError('Token manquant');
      setLoading(false);
    }
  }, []);

  const fetchAllHypotheques = async () => {
    setLoading(true);
    try {
      const response = await api.post("/auth/getAllHypothequesByUserId", {
        id_user: idUser
      });

      if (response.data.status) {
        setHypotheques(response.data.response);

      } else {
        setError("Aucune hypothèque trouvée");
      }
    } catch (error) {
      setError("Erreur lors de la récupération des données.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!idUser) return;
    fetchAllHypotheques();
  }, [idUser]);

  return (
    <div className='container text-center mt-5'>
      <div className='row'>
        {loading ? (
          <div className='container-fluid'>
            {error ? (
              <div className='alert alert-danger' role='alert'>
                {error}
              </div>
            ) : (
              <div>Chargement...</div>
            )}
          </div>
        ) : hypotheques.length > 0 ? (
          hypotheques.map((hypo, index) => (
            <div key={index} className='col-12 col-md-4 mb-4'>
              <div className='card h-100'>
                <div className='card-body'>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <th className="text-start">N° Demande</th>
                        <td className="text-end">{hypo.num_demande}</td>
                      </tr>
                      <tr>
                        <th className="text-start">Banque</th>
                        <td className="text-end">{hypo.libelle}</td>
                      </tr>
                      <tr>
                        <th className="text-start">Rang hypo</th>
                        <td className="text-end">{hypo.rang_hypo}</td>
                      </tr>
                      <tr>
                        <th className="text-start">TF</th>
                        <td className="text-end">
                          <span className="badge bg-warning text-white">
                            {hypo.TFs}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th className="text-start">Montant</th>
                        <td className="text-end">
                          <span className="fw-bold text-success">
                            
                            {hypo.montant.toLocaleString('fr-FR', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })} MRU

                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th className="text-start">Date hypothèque</th>
                        <td className="text-end">{hypo.date_hypo}</td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="row">
                    <div className="col-12">
                      <button className="btn btn-success btn-sm w-100"
                        onClick={() => navigate(`/hypotheque/show/${hypo.hypo_id}`)}
                      >
                        Voir
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          ))
        ) : (
          <div className='container-fluid'>
            <div class="alert alert-danger" role="alert">
            Aucune hypothèque trouvée.
          </div>
          </div>

        )}
      </div>
    </div>
  );
};

export default MesHypotheques;
